const AccordianData = [
    {
        id: "1",
        question: "What is our Goal?",
        answer: "Our Goal is..."
    },
    {
        id: "2",
        question: "What is our Mission?",
        answer: "Our Mission is..."
    },
    {
        id: "3",
        question: "What services do we offer?",
        answer: "Our services are..."
    }
];

export default AccordianData